module.exports = __webpack_public_path__ + "static/media/rpandey.439ce5e5.jpg";